<template>
    <div>
        <v-card id="container" flat height="300">
            <v-card-title class="d-flex align-center py-1">
                <h6 class="mr-auto">Operating System</h6>
            </v-card-title>

            <v-divider></v-divider>

            <div v-if="os_distribution.length">
                <apexchart type="radialBar" height="270" :options="chartOptions" :series="series"></apexchart>
            </div>

            <div v-else>
                <v-card height="255" flat class="d-flex align-center justify-center">
                    <div class="text-center py-10">
                        <v-icon x-large>mdi-alert-circle-outline</v-icon>
                        <p class="text-caption text-disabled">No data available</p>
                    </div>
                </v-card>
            </div>

        </v-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            series: [],
            chartOptions: {
                chart: {
                    height: 270,
                    type: 'radialBar',
                },
                plotOptions: {
                    radialBar: {
                        offsetY: 0,
                        startAngle: 0,
                        endAngle: 270,
                        hollow: {
                            margin: 5,
                            size: '30%',
                            background: 'transparent',
                            image: undefined,
                        },
                        dataLabels: {
                            name: {
                                show: false,
                            },
                            value: {
                                show: false,
                            }
                        }
                    }
                },
                colors: ['#77c1ab', '#6092c0', '#d36085', '#ffb01a', '#00E396'],
                labels: [],
                legend: {
                    show: true,
                    floating: true,
                    fontSize: '14px',
                    position: 'left',
                    offsetX: -20,
                    offsetY: -8,
                    labels: {
                        useSeriesColors: false,
                    },
                    markers: {
                        size: 0
                    },
                    formatter: function (seriesName, opts) {
                        let value = opts.w.globals.series[opts.seriesIndex]?.toLocaleString()
                        return seriesName + ":  " + value
                    },
                    itemMargin: {
                        vertical: 3
                    }
                },
            },
        }
    },
    props: {
        campaign: {
            type: String,
            validator: function (value) {
                return Number(value);
            }
        },
    },

    watch: {
        os_distribution: {
            handler: function (val) {
                // Extracting keys array
                const osNames = val.map(item => item.key);

                //if OS name is android capitalize the first letter
                const capitalizedNames = osNames.map(name => {
                    if (name.toLowerCase() === 'android') {
                        return name.charAt(0).toUpperCase() + name.slice(1);
                    } else {
                        return name;
                    }
                });

                // Extracting document counts array
                const data = val.map(item => item.doc_count);


                //set that to series
                this.series = data;

                // //set that to chart options
                this.chartOptions = {
                    ...this.chartOptions,
                    labels: capitalizedNames
                };
            },
            deep: true
        },
    },
    mounted() {
        this.getOperatingSystemDistribution();
    },

    computed: {
        os_distribution() {
            return this.$store.state.dsp.os_distribution
        }
    },

    methods: {
        //Get top carriers
        async getOperatingSystemDistribution() {

            this.loading = true;

            try {

                let body = {
                    "campaign": this.campaign,
                    "body": {
                        "size": 0,
                        "query": {},
                        "aggs": {
                            "test_histogram": {
                                "terms": {
                                    "field": "r_device.os.keyword",
                                    "size": 10
                                }
                            }
                        }
                    }
                }

                await this.$store.dispatch("dsp/getOperatingSystemDistribution", body);

            } catch (error) {
                console.log(error);
            } finally {
                this.loading = false;
            }
        },
    }
}
</script>